import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {LaboratoryDetail} from "./laboratory-detail";

const LaboratoryDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/laboratories');
    }

    return (
        <LaboratoryDetail id={id} onClose={onClose}/>
    )

});

export default LaboratoryDetailPage;